export default __webpack_public_path__ + "static/media/03.e990ba7c.jpg";